import { render, staticRenderFns } from "./createBlog.vue?vue&type=template&id=4fe73d6b&scoped=true&"
import script from "./createBlog.vue?vue&type=script&lang=js&"
export * from "./createBlog.vue?vue&type=script&lang=js&"
import style0 from "./createBlog.vue?vue&type=style&index=0&id=4fe73d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe73d6b",
  null
  
)

export default component.exports